
    import './styles.scoped.css';
    export default {
  "key-value-pairs": "awsui_key-value-pairs_1y9fy_nibxc_141",
  "group-title": "awsui_group-title_1y9fy_nibxc_176",
  "group-list": "awsui_group-list_1y9fy_nibxc_180",
  "group-list-item": "awsui_group-list-item_1y9fy_nibxc_190",
  "term": "awsui_term_1y9fy_nibxc_194",
  "key-label": "awsui_key-label_1y9fy_nibxc_202",
  "detail": "awsui_detail_1y9fy_nibxc_210",
  "info": "awsui_info_1y9fy_nibxc_248"
};
  